{
  "comment": "M7 spec §2.1–§2.2 (S3 owns): the report thread's logs. Log shape: src/story/schemas.ts evidenceLogSchema (at most ~120 words or one table; form carries the fact). Ids are unique across every evidence file; this file's ids start 'report.'. Okafor's report and the routing slip are the contents of the report_core story item (Mission 3, weight 3); his lab notes are the lab_notes fallback (weaker, weight 1). The report reached operations as 'a possible correlation' (canon §8 #2). OPS-R/7 hides Voss until the routing slip (canon §8 #8). Voss's counter logs: report.counter_survey_bulletin and report.counter_evac_fund (weight 0: her case, never the player's proof). Leads to the hideout relay are fromTier 3, so nothing points at okafor-hideout before Mission 3 can be offered (spec §6). Template slots are {name} in braces: {member}, {posting}, {order} for the repeatable coverup corroboration (a transfer order a Holdfast contract recovers, spec §2.5). Every name, code and date is a placeholder until the naming pass (spec §15 item 7). Claim words for tier 4 (spec §2.3): okafor/lindqvist/voss (names), ops_r7/fin_r2 (codes), defunded/postponed (verbs); natural_cycle and gate_fault are decoys.",
  "logs": [
    {
      "id": "report.stores_return",
      "thread": "report",
      "link": "none",
      "kind": "lead",
      "weight": 1,
      "title": "Stores return slip, Carrow Lab 2",
      "date": "CY8 d141",
      "source": "derelictCore",
      "body": "TETHYS MINING COMBINE · STORES · RETURN SLIP SR-8-2210\nFrom: Carrow Lab 2 (Survey and Materials Research)\nReason: group dissolved, per transfer order TO-8-0932\nLab sealed CY8 d141. Location on the reverse.",
      "table": {
        "columns": ["Item", "Condition", "Disposition"],
        "rows": [
          ["Resonance bench RB-2", "working", "decommission, do not re-issue"],
          ["Transit timing recorder", "working", "decommission"],
          ["Working notes, 14 binders", "complete", "return to stores"],
          ["Kettle", "working", "left in lab"]
        ]
      },
      "words": [],
      "lead": { "systemHint": "okafor-lab", "poiKind": "derelict" },
      "fromTier": 1
    },
    {
      "id": "report.survey_memo_redacted",
      "thread": "report",
      "link": "knowledge",
      "kind": "proof",
      "weight": 1,
      "title": "Survey memo, redacted copy",
      "date": "CY8 d97",
      "source": "frResearchDerelict",
      "body": "INTERNAL · SURVEY AND MATERIALS RESEARCH · CY8 d97\nTo: Operations, Reach Division\nFrom: I. Okafor\nRe: Transit variance and FC-6 extraction volume, rev. 3\n\nSummary: Gate transit variance shows a possible correlation with FC-6 extraction at Carrow, lagged 6-11 minutes. Sample is small (n = 14 cuts). [redacted]. A possible mechanism is [redacted]. Further study advised before operational change.\n\nRev. 1 summary: [withdrawn by author]\nRev. 2 summary: [withdrawn by author]\nDistribution: Operations only. Copies: 1.",
      "words": ["okafor"],
      "fromTier": 2
    },
    {
      "id": "report.evac_plan_budget",
      "thread": "report",
      "link": "coverup",
      "kind": "proof",
      "weight": 1,
      "title": "Reach Division budget revision, CY9",
      "date": "CY8 d160",
      "source": "derelictCore",
      "body": "TETHYS MINING COMBINE · REACH DIVISION · BUDGET REVISION, CY9\nApproved: OPS-R/7. Countersigned: FIN-R/2.\nCirculation: Operations, Finance. Not to Survey.",
      "table": {
        "columns": ["Budget line", "CY8 (M cr)", "CY9 (M cr)", "Status"],
        "rows": [
          ["Extraction, Carrow fracture vein", "4.1", "9.6", "expanded"],
          ["Evacuation contingency, Reach", "2.2", "0", "defunded"],
          ["Gate queue drills, settler liners", "0.3", "0", "postponed"],
          ["Survey and Materials Research", "0.6", "0", "dissolved"],
          ["Hauler fleet, TH- series", "3.0", "5.8", "expanded"],
          [
            "Charter Fund, standing order R/7-3: persons in available holds",
            "0",
            "15% of FC-6 proceeds",
            "replaces contingency"
          ]
        ]
      },
      "words": ["ops_r7", "fin_r2", "defunded", "postponed"],
      "fromTier": 2
    },
    {
      "id": "report.transfer_order",
      "thread": "report",
      "link": "coverup",
      "kind": "proof",
      "weight": 1,
      "title": "Personnel transfer order TO-8-0932",
      "date": "CY8 d140",
      "source": "frResearchDerelict",
      "body": "TETHYS MINING COMBINE · PERSONNEL TRANSFER ORDER TO-8-0932\nEffective CY8 d140 · Authorised OPS-R/7\nSurvey and Materials Research Group (lead: Dr I. Okafor) is dissolved.\nInstruments and working notes: return to stores.",
      "table": {
        "columns": ["Name", "From", "To"],
        "rows": [
          ["I. Okafor", "Carrow Lab 2", "Relay Station Brisk (Senn Deep), upkeep"],
          ["P. Lindqvist", "Carrow Lab 2", "Tollen Drift, assay"],
          ["M. Oyelaran-Choi", "Carrow Lab 2", "Export Terminal, stores"],
          ["R. Castellane", "Carrow Lab 2", "[contract ended]"]
        ]
      },
      "words": ["okafor", "lindqvist", "ops_r7"],
      "lead": { "systemHint": "okafor-hideout", "poiKind": "relay" },
      "fromTier": 3
    },
    {
      "id": "report.kell_old_man",
      "thread": "report",
      "link": "none",
      "kind": "lead",
      "weight": 1,
      "title": "Nav fix, sent by Kell",
      "date": "CY60",
      "source": "kellComms",
      "body": "CO-OP TRADE LINE · T. Kell\nFix attached. Relay Station Brisk, Senn Deep. The relay's been down since CY12; you'll have to fix the lane to get in.\nThere's an old man out there. Bring him filters.\nHe won't want to talk to you.",
      "words": [],
      "lead": { "systemHint": "okafor-hideout", "poiKind": "relay" },
      "fromTier": 3
    },
    {
      "id": "report.brisk_supply_manifest",
      "thread": "report",
      "link": "none",
      "kind": "lead",
      "weight": 1,
      "title": "Supply manifest, Relay Station Brisk",
      "date": "CY9 d30",
      "source": "convoyWreck",
      "body": "TETHYS MINING COMBINE · RELAY SUPPLY RUN · Senn Deep line\nPurser's note: Brisk crew is one man. He asked for paper. We had none.",
      "table": {
        "columns": ["Stop", "Crew", "Delivered"],
        "rows": [
          ["Relay Station Ardent", "4", "rations 120 days, filters 12"],
          ["Relay Station Brisk", "1 (I. Okafor)", "rations 90 days, filters 4"],
          ["Relay Station Callow", "3", "rations 90 days, filters 9"]
        ]
      },
      "words": ["okafor"],
      "lead": { "systemHint": "okafor-hideout", "poiKind": "relay" },
      "fromTier": 3
    },
    {
      "id": "report.okafor_report",
      "thread": "report",
      "link": "knowledge",
      "kind": "proof",
      "weight": 3,
      "title": "SMR memo, rev. 3, with withdrawn drafts",
      "date": "CY8 d97",
      "source": "missionItem",
      "body": "SEALED CORE · CARROW LAB 2 · BAY 4\nINTERNAL · SURVEY AND MATERIALS RESEARCH · rev. 3, as sent\nFrom: I. Okafor\nSummary: Gate transit variance shows a possible correlation with FC-6 extraction at Carrow, lagged 6-11 minutes. Sample is small (n = 14 cuts). A possible mechanism is field anchoring by the FC-6 lattice. Further study advised before operational change.\n\nRev. 1 (withdrawn by author): Transit variance tracks FC-6 extraction within 11 minutes in every sample. If Carrow rates double, expect transit loss within two years.\nRev. 2 (withdrawn by author): as rev. 1, \"two years\" struck out.",
      "words": ["okafor"],
      "item": "report_core",
      "fromTier": 3
    },
    {
      "id": "report.routing_slip",
      "thread": "report",
      "link": "coverup",
      "kind": "proof",
      "weight": 3,
      "title": "Routing slip, SMR memo rev. 3",
      "date": "CY8 d98",
      "source": "missionItem",
      "body": "ROUTING SLIP · attached: SMR memo rev. 3 (1 copy)\nAction: HOLD. Do not copy. Do not file to Survey.\nInitialled: MV",
      "table": {
        "columns": ["Step", "From", "To", "Status"],
        "rows": [
          ["1", "I. Okafor", "Operations, Reach Div.", "sent CY8 d97"],
          ["2", "Operations", "M. Voss, Operations Chief, desk R/7 (OPS-R/7)", "received CY8 d98"],
          ["3", "OPS-R/7", "", "no onward routing"]
        ]
      },
      "words": ["okafor", "voss", "ops_r7"],
      "item": "report_core",
      "fromTier": 3
    },
    {
      "id": "report.lab_notes",
      "thread": "report",
      "link": "knowledge",
      "kind": "proof",
      "weight": 1,
      "title": "Okafor's lab notes",
      "date": "CY8",
      "source": "missionItem",
      "body": "Bench notebook, Carrow Lab 2. Okafor's hand. Coffee rings.\nLast page: \"Sent rev. 3. Kept 1 and 2 here. Coward's copy.\"",
      "table": {
        "columns": ["Day", "Carrow FC-6 cut (t)", "Gate transit variance", "Lag"],
        "rows": [
          ["CY8 d61", "40", "0.1", "-"],
          ["CY8 d70", "220", "0.3", "7 min"],
          ["CY8 d78", "410", "0.5", "9 min"],
          ["CY8 d85", "60", "0.1", "-"],
          ["CY8 d90", "390", "0.5", "11 min"]
        ]
      },
      "words": ["okafor"],
      "item": "lab_notes",
      "fromTier": 3
    },
    {
      "id": "report.counter_survey_bulletin",
      "thread": "report",
      "link": "none",
      "kind": "counter",
      "weight": 0,
      "title": "Tethys Survey Bulletin 11",
      "date": "CY10 d280",
      "source": "authorityArchive",
      "body": "TETHYS MINING COMBINE · SURVEY BULLETIN 11 · filed with the Charter Authority\nFinding: gate transit records CY1-CY10 show variance on a natural cycle, period estimated 46-58 years, consistent with the records of the gate's first survey. No gate fault attributable to operations. Extraction at Carrow is not a factor at the volumes recorded.\nPrepared for Operations, Reach Division. Peer review: not required.\nCited in Commission proceedings, CY10.",
      "words": ["natural_cycle", "gate_fault"],
      "fromTier": 2
    },
    {
      "id": "report.counter_evac_fund",
      "thread": "report",
      "link": "none",
      "kind": "counter",
      "weight": 0,
      "title": "Evacuation Charter Fund statement, CY10",
      "date": "CY10 d215",
      "source": "derelictCore",
      "body": "TETHYS MINING COMBINE · EVACUATION CHARTER FUND · statement\nFunded by standing order R/7-3: 15% of FC-6 proceeds, CY9-CY10.\nEvery hull below cleared the gate before it went dark.",
      "table": {
        "columns": ["Hull", "Chartered by the fund", "Persons out"],
        "rows": [
          ["SL Anselm Rook", "CY10 d201", "1,900"],
          ["SL Marrow Bay", "CY10 d202", "1,640"],
          ["TH-0417, hold 3", "CY10 d208", "212"],
          ["SL Hesper Line", "CY10 d204", "1,120"],
          ["Total", "", "4,872"]
        ]
      },
      "words": [],
      "fromTier": 2
    },
    {
      "id": "report.lindqvist_assay_note",
      "thread": "report",
      "link": "none",
      "kind": "texture",
      "weight": 0,
      "title": "Assay shift note, Tollen Drift",
      "date": "CY13 d52",
      "source": "derelictCore",
      "body": "TOLLEN DRIFT ASSAY · SHIFT NOTE · P. Lindqvist\nSamples run: 0. Nothing came in. Nothing has come in since the gate.\nFixed the hab ring's water meter instead. They were short-measuring the night shift.\nIf anyone from Carrow Lab 2 reads this: Idris, Meseret, Rafe. I still have the kettle's lid. I don't know why I took it.\nNext shift: me.",
      "words": ["lindqvist"],
      "fromTier": 1
    },
    {
      "id": "report.corr_transfer_order",
      "thread": "report",
      "link": "coverup",
      "kind": "proof",
      "weight": 1,
      "title": "Recovered transfer order",
      "date": "CY8",
      "source": "holdfastContract",
      "body": "TETHYS MINING COMBINE · PERSONNEL TRANSFER ORDER {order}\nAuthorised OPS-R/7\nName: {member}, Survey and Materials Research (dissolved)\nFrom: Carrow Lab 2\nTo: {posting}\nWorking notes: return to stores.\nRecovered by a Holdfast crew and passed on by Kell.",
      "words": [],
      "fromTier": 3,
      "repeatable": true,
      "template": true
    }
  ]
}
